// extracted by mini-css-extract-plugin
module.exports =  {"link":"_32bbee5fda--link--ij_Qj","button":"_32bbee5fda--button--QfX4r"};